import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "../styles/hero-carousel.css";

import slide1 from "../assets/images/hero/local-front.JPEG";
import slide2 from "../assets/images/hero/motosierra.jpg";
import slide3 from "../assets/images/hero/motoguadaña.jpeg";
import slide4 from "../assets/images/hero/hidrolavadora.jpg";
import slide5 from "../assets/images/hero/soplador.webp";
import slide6 from "../assets/images/hero/cortacercos.jpg";
import slide7 from "../assets/images/hero/cortadora.jpg";
import slide8 from "../assets/images/hero/generador.jpg";
import slide9 from "../assets/images/hero/tractor.webp";
import slide10 from "../assets/images/hero/motocultivador.jpg";

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: slide1,
      title: "CONCESIONARIO OFICIAL",
      subtitle: "STIHL",
      description: "Equipamiento profesional para cada desafío",
    },
    {
      id: 2,
      image: slide2,
      title: "MOTOSIERRAS",
      subtitle: "STIHL",
      description: "Potencia sin límites",
    },
    {
      id: 3,
      image: slide3,
      title: "MOTOGUADAÑAS",
      subtitle: "STIHL",
      description: "Tecnología de vanguardia",
    },
    {
      id: 4,
      image: slide4,
      title: "HIDROLAVADORAS",
      subtitle: "STIHL",
      description: "Limpieza profesional",
    },
    {
      id: 5,
      image: slide5,
      title: "SOPLADORES PROFESIONALES",
      subtitle: "STIHL",
      description: "Rendimiento superior",
    },
    {
      id: 6,
      image: slide6,
      title: "CORTACERCOS PROFESIONAL",
      subtitle: "STIHL",
      description: "Precisión en cada corte",
    },
    {
      id: 7,
      image: slide7,
      title: "CORTADORAS DE CÉSPED",
      subtitle: "STIHL",
      description: "Corte perfecto y jardín impecable",
    },
    {
      id: 8,
      image: slide8,
      title: "GENERADORES",
      subtitle: "STIHL",
      description: "Energía confiable donde la necesites",
    },
    {
      id: 9,
      image: slide9,
      title: "TRACTORES CORTACÉSPED",
      subtitle: "STIHL",
      description: "Máxima comodidad y eficiencia",
    },
    {
      id: 10,
      image: slide10,
      title: "MOTOCULTIVADORES",
      subtitle: "STIHL",
      description: "Prepará tu tierra como un profesional",
    },
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [slides.length]);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 9000);
    return () => clearInterval(timer);
  }, [currentSlide, nextSlide]);

  return (
    <section className="hero-carousel">
      <div className="carousel-slides">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`carousel-slide ${index === currentSlide ? "active" : ""}`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              loading={index === 0 ? "eager" : "lazy"}
              fetchpriority={index === 0 ? "high" : "low"}
            />
            <div className="carousel-overlay">
              <div className="carousel-content">
                <div className="carousel-badge">{slide.title}</div>
                <h1 className="carousel-title">{slide.subtitle}</h1>
                <p className="carousel-description">{slide.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        className="carousel-arrow prev"
        onClick={prevSlide}
        aria-label="Anterior"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <button
        className="carousel-arrow next"
        onClick={nextSlide}
        aria-label="Siguiente"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>

      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            aria-label={`Ir a slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroCarousel;
